import { Component } from '@angular/core';
import { DataService } from '../../shared/dataService';
import { BlogEntry } from '../../shared/blogEntry';
import { Router } from '@angular/router';

@Component({
    selector: 'new-blog',
    templateUrl: "./newBlog.component.html",
    //  template: `
    //  <div style="text-align:center" class="content">
    //    <h1>
    //      Welcome to {{title}}!
    //    </h1>
    //  </div>
    //`,
    styles: []
})
export class NewBlogComponent {
    errorMessage: string = "";
    constructor(private data: DataService, private router: Router) {

    }

    title = 'New Blog Entry';

    public blogEntry: BlogEntry = new BlogEntry();

    addBlogEntry() {
        this.blogEntry.createdAt = new Date();
        //this.blogEntry.text = "new blog 1";

        this.data.addBlogEntry(this.blogEntry)
            .subscribe(success => {
                if (success) {
                    this.router.navigate([""]);
                }
            }, err => this.errorMessage = "Failed to save blog entry");
    }
}
